// removed by extract-text-webpack-plugin
module.exports = {"root":"root___1pVD4","centered":"centered___gAjzM","compact":"compact___3lDn0","title":"title___LZj5f","separator":"separator___3ow_M","brand":"brand___hIBi3","primary":"primary___12wqd","negative":"negative___ZCMwp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Title/index.scss
// module id = 108
// module chunks = 0